(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSActividadController', SSActividadController);

    SSActividadController.$inject = ['SSActividad'];

    function SSActividadController(SSActividad) {

        var vm = this;

        vm.sSActividads = [];

        loadAll();

        function loadAll() {
            SSActividad.query(function(result) {
                vm.sSActividads = result;
                vm.searchQuery = null;
            });
        }
    }
})();
